<template>
  <div :class="$b()">
    <BaseLink
      :to="target"
      :class="$b('link')"
      @click="$emit('click')"
    >
      <DynamicImage
        :image="image"
        aspect-ratio="1:1"
        no-fade
        :class="$b('image')"
        :transform-widths="[500]"
        :sizes="[{ width: 500 }]"
      >
        <div :class="$b('title-container')">
          <VisionIcon
            icon="arrow"
            :class="$b('arrow')"
          />
          <BaseHeading
            :tag="titleHtmlTag || 'h3'"
            size="h3"
            :class="$b('title')"
          >
            {{ title }}
          </BaseHeading>
          <p v-if="subtitle">
            {{ subtitle }}
          </p>
        </div>
        <div
          :class="$b('overlay')"
          :style="{ opacity: overlayOpacity / 100 }"
        />
        <div :class="$b('gradient-overlay')" />
      </DynamicImage>
    </BaseLink>
  </div>
</template>

<script>
export default {
  name: 'CarouselItem',

  props: {
    title: { type: String, required: true },
    titleHtmlTag: { type: String, required: true },
    subtitle: { type: String, required: false, default: '' },
    target: { type: String, required: true },
    overlayOpacity: { type: Number, required: true },
    image: { type: Object, required: true },
  },

  emits: ['click']
}
</script>

<style lang="postcss">
.CarouselItem {
  @apply flex-shrink-0
    overflow-hidden;

  border-radius: 10px;
}

.CarouselItem__link,
.CarouselItem__image {
  @apply w-full;
}

/* Is there a better way to achieve this? */
.CarouselItem__image {
  padding-bottom: 135% !important;

  @screen md {
    padding-bottom: 100% !important;
  }
}

.CarouselItem__overlay {
  @apply absolute
    w-full h-full
    top-0 left-0
    bg-black;
}

.CarouselItem__gradient-overlay {
  @apply absolute
    w-full h-full
    top-0 left-0
    opacity-0;

  background-image: var(--gradient-default);

  .CarouselItem__link:hover & {
    @apply lg:opacity-60;
  }
}

.CarouselItem__title-container {
  @apply text-white
    absolute
    pr-sm sm:pr-md
    bottom-sm left-sm sm:bottom-md sm:left-md;

  z-index: 2;
}

.CarouselItem__title {
  @apply text-white transition-transform
    mdMax:text-md;

  z-index: 2;

  .CarouselItem__link:hover & {
    @screen lg {
      transform: translate3d(40px, 0, 0);
    }
  }
}

.CarouselItem__arrow {
  @apply absolute transition opacity-0;

  transform: translate3d(-50px, 2px, 0);

  .CarouselItem__link:hover & {
    @screen lg {
      opacity: 1;
      transform: translate3d(0, 2px, 0);
    }
  }
}
</style>
